"use client";

import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function LoadingScreen() {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Hide loading screen after page loads
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 800); // Reduced minimum display for better performance

        return () => clearTimeout(timer);
    }, []);

    return (
        <AnimatePresence>
            {isLoading && (
                <motion.div
                    initial={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.5, ease: "easeInOut" }}
                    className="fixed inset-0 z-[9999] flex items-center justify-center bg-gradient-to-br from-slate-900 via-primary/20 to-slate-900"
                >
                    {/* Animated Logo/Brand */}
                    <div className="relative flex flex-col items-center gap-6">
                        {/* Pulsing circles */}
                        <div className="relative">
                            <motion.div
                                animate={{
                                    scale: [1, 1.5, 1],
                                    opacity: [0.5, 0.2, 0.5],
                                }}
                                transition={{
                                    duration: 2,
                                    repeat: Infinity,
                                    ease: "easeInOut",
                                }}
                                className="absolute inset-0 rounded-full bg-primary/30 blur-xl"
                                style={{ width: 120, height: 120, margin: -30 }}
                            />
                            <motion.div
                                animate={{
                                    scale: [1, 1.3, 1],
                                    opacity: [0.7, 0.3, 0.7],
                                }}
                                transition={{
                                    duration: 1.5,
                                    repeat: Infinity,
                                    ease: "easeInOut",
                                    delay: 0.2,
                                }}
                                className="absolute inset-0 rounded-full bg-primary/50 blur-lg"
                                style={{ width: 80, height: 80, margin: -10 }}
                            />

                            {/* Globe icon */}
                            <motion.div
                                animate={{ rotate: 360 }}
                                transition={{
                                    duration: 8,
                                    repeat: Infinity,
                                    ease: "linear",
                                }}
                                className="relative w-16 h-16 rounded-full border-2 border-primary/60 flex items-center justify-center"
                            >
                                <div className="absolute inset-2 rounded-full border border-primary/40" />
                                <div className="absolute h-full w-px bg-primary/40 left-1/2 -translate-x-1/2" />
                                <div className="absolute w-full h-px bg-primary/40 top-1/2 -translate-y-1/2" />
                            </motion.div>
                        </div>

                        {/* Brand text */}
                        <motion.div
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.3 }}
                            className="text-center"
                        >
                            <h1 className="text-2xl font-bold text-white tracking-wider">
                                FINTEK
                            </h1>
                            <p className="text-sm text-primary/80 tracking-widest">
                                WORLDWIDE
                            </p>
                        </motion.div>

                        {/* Loading bar */}
                        <motion.div
                            className="w-48 h-1 bg-white/10 rounded-full overflow-hidden"
                        >
                            <motion.div
                                initial={{ x: "-100%" }}
                                animate={{ x: "100%" }}
                                transition={{
                                    duration: 1,
                                    repeat: Infinity,
                                    ease: "easeInOut",
                                }}
                                className="h-full w-1/2 bg-gradient-to-r from-transparent via-primary to-transparent"
                            />
                        </motion.div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
